<ul class="navbar-nav" *ngIf="isAuthenticated | async">
  <li class="nav-item">
    <a class="nav-link text-dark" [routerLink]='["/authentication/manage-users"]' *ngIf="isAdmin | async">Beheer gebruikers</a>
  </li>
  <li class="nav-item">
    <a class="nav-link text-dark" [routerLink]='["/authentication/profile"]' title="Beheer account"><i class="fa-solid fa-user"></i></a>
  </li>
  <li class="nav-item">
    <a class="nav-link text-dark" [routerLink]='["/authentication/logout"]' [state]='{ local: true }' title="Uitloggen"><i class="fa-solid fa-right-from-bracket"></i></a>
  </li>
</ul>
<ul class="navbar-nav" *ngIf="!(isAuthenticated | async)">
  <li class="nav-item">
    <a class="nav-link text-dark" [routerLink]='["/authentication/register"]' *ngIf="isAdmin | async">Registreer</a>
  </li>
  <li class="nav-item">
    <a class="nav-link text-dark" [routerLink]='["/authentication/login"]' title="Inloggen"><i class="fa-solid fa-right-to-bracket"></i></a>
  </li>
</ul>
